import { gql } from "@apollo/client"

export const GET_USER = gql`
  query getUser {
    myUser {
      firstName
      lastName
      email
      organization {
        id
        name
      }
      title
      mobilePhoneNumber
      profile {
        id
        imageUrl
      }
      groups {
        id
        name
      }
      shippingAddress {
        address1
        address2
        city
        zipCode
        country
      }
      organization {
        id
        name
      }
      hasTotp
      id
    }
  }
`
